import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Input } from '../../Input';
var filterSuggestions = function (text, suggestions) {
    if (!text || !suggestions) {
        return suggestions;
    }
    return suggestions.filter(function (suggestion) { return suggestion.includes(text) && suggestion !== text; });
};
var BaseInput = function (props) {
    var _a, _b;
    var value = props.value, readonly = props.readonly, disabled = props.disabled, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, options = props.options, schema = props.schema, formContext = props.formContext, dir = props.dir, inputProps = __rest(props, ["value", "readonly", "disabled", "autofocus", "onBlur", "onFocus", "options", "schema", "formContext", "dir"]);
    var change = function (_a) {
        var value = _a.target.value;
        return props.onChange(value === '' ? options.emptyValue : value);
    };
    var suggestions = filterSuggestions(value, schema.examples);
    var hasExamples = ((_b = (_a = schema.examples) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, __assign({ width: "100%", readOnly: readonly, disabled: disabled, autoFocus: autofocus, autoComplete: hasExamples ? 'off' : options.autoComplete, emphasized: options.emphasized, value: value == null ? '' : value, type: schema.type === 'number'
                ? 'number'
                : options.inputType || 'text', dir: dir }, inputProps, { onChange: change, onBlur: onBlur && (function (event) { return onBlur(inputProps.id, event.target.value); }), onFocus: onFocus &&
                (function (event) { return onFocus(inputProps.id, event.target.value); }), onSelect: function (e) { return props.onChange(e.suggestion); }, suggestions: suggestions, list: hasExamples ? 'dummy-datalist' : undefined })),
        hasExamples && React.createElement("datalist", { id: "dummy-datalist" })));
};
export default BaseInput;
